import { render } from "./StatusManual.vue?vue&type=template&id=1a0904be"
import script from "./StatusManual.vue?vue&type=script&lang=js"
export * from "./StatusManual.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__